/**
 * Unwraps a tool result's `{type:"json", value:{results}}` envelope — the shape
 * every `SharedTool` returns, sometimes arriving as a JSON string on a replayed
 * transcript. Shared by every transcript reader so each reads the wire the same
 * way.
 */
export function readToolJsonResults(
  output: unknown
): Record<string, unknown> | null {
  if (!output || typeof output !== "object" || !("type" in output)) {
    return null;
  }
  if (
    output.type === "text" &&
    "value" in output &&
    typeof output.value === "string"
  ) {
    try {
      return readToolJsonResults(JSON.parse(output.value));
    } catch {
      return null;
    }
  }
  if (output.type !== "json" || !("value" in output)) {
    return null;
  }
  const value = output.value;
  if (!value || typeof value !== "object" || !("results" in value)) {
    return null;
  }
  const results = value.results;
  return results && typeof results === "object"
    ? (results as Record<string, unknown>)
    : null;
}
